import { connectedStore } from '../../store';
import view from '../../view';

const windowLoadHandler = () => {
  const store = connectedStore.get();
  store.dispatch(view.actions.setLoadedStatus(true));
};

export default windowLoadHandler;
